module.exports = __webpack_public_path__ + "static/img/1.c24a0fd8.png";